import { RouteSheet } from '@/components/route-sheet';
import { useGetMatchedRoute } from '@/hooks/routing';
import { useI18n } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute, useLocation } from '@tanstack/react-router';

export const Route = createFileRoute('/(home)/home/(change-password)/_sheet')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { t } = useI18n();
  const match = useGetMatchedRoute();
  const { state } = useLocation();
  let hasBack = false;
  let backAsRouterNavigateBack = false;
  let title = '';
  let subtitle: string | undefined;
  switch (match.routeId) {
    case '/(home)/home/(change-password)/_sheet/change-password/(landing-page)/':
      hasBack = false;
      title = t('Home.ChangePassword.Title');
      subtitle = t('Home.ChangePassword.Description');
      break;
    case '/(home)/home/(change-password)/_sheet/change-password/contact-selection/':
      hasBack = true;
      title = t('Common.ContactValidation.ContactSelection.SheetTitle');
      break;
    case '/(home)/home/(change-password)/_sheet/change-password/code-input/': {
      const { contactType, targetId } = (state ?? {}) as {
        contactType?: string;
        targetId?: string;
      };
      const descriptionKey =
        contactType === 'Sms'
          ? 'Common.ContactValidation.CodeInput.Description.Phone'
          : 'Common.ContactValidation.CodeInput.Description.Email';
      hasBack = true;
      backAsRouterNavigateBack = true;
      title = t('Common.ContactValidation.CodeInput.SheetTitle');
      subtitle = t(descriptionKey, { contact: targetId });
      break;
    }
    case '/(home)/home/(change-password)/_sheet/change-password/new-password/':
      backAsRouterNavigateBack = true;
      title = t('Home.NewPassword.Title');
      break;
  }

  return (
    <RouteSheet
      onClose={() => navigate({ to: '/home' })}
      options={{ hasBack, backAsRouterNavigateBack, title, subtitle }}
    />
  );
}
